import { Component } from "../component"
import { scrollLoop } from "../helpers/scroll-loop"
import { iterable } from "../helpers/iterable"
import { debounce } from "../helpers/debounce"

const VALID_PARAMS = ["category", "material", "stone", "sort_by"]

export class CollectionProducts extends Component {
  constructor(props) {
    super(props)

    this.state = {}

    this.dynamicClasses = {
      expanded: "-expanded",
      allowSticky: "-allow-sticky",
      sticky: "-sticky",
      stickyExt: "-sticky-ext",
      border: "-border",
      active: "-active",
      open: "-open",
      loading: "-loading",
      hidden: "-hidden",
      customBlocksHidden: "-custom-blocks-hidden",
      disabled: "-disabled",
      initObserved: "-init-observed",
      notObserved: "-not-observed",
      empty: "-empty",
      filtersAppliedEmpty: "-filters-applied-empty",
      multiRows: "-multi-rows",
    }
  }

  ui() {
    return {
      controls: ".collection-controls",
      filters: ".collection-filters",
      filtersToggle: ".collection-filters-toggle",
      filtersContent: ".collection-filters-content",
      filtersContentClose: ".collection-filters-content-close",
      filtersColumnTitle: ".collection-filters-content-title",
      filtersContentColumnTitles: ".collection-filters-content-column-title",
      filtersContentItems: ".collection-filters-content-items",
      filtersContentControlsButtons:
        ".collection-filters-content-controls-button",
      filtersApplied: ".collection-filters-applied",
      filtersAppliedItems: ".collection-filters-applied-items",
      filtersAppliedToggle: ".collection-filters-applied-toggle",
      sortLabel: ".collection-sort-label",
      sortOptions: ".collection-sort .dropdown-option",
      sortInputs: ".collection-sort .dropdown-option-input",
      productGridContainer: ".product-grid-container",
    }
  }

  setHeights() {
    const { filtersContent, filtersContentItems } = this.$ui

    if (window.innerWidth >= 1024) {
      filtersContent.style.height = "auto"
      filtersContent.dataset.height = `${filtersContent.offsetHeight}px`
      filtersContent.removeAttribute("style")
    } else {
      iterable(filtersContentItems).forEach((column) => {
        column.style.height = "auto"
        column.dataset.height = `${column.offsetHeight}px`
        column.removeAttribute("style")
      })
    }
  }

  toggleFilters() {
    const { filters, filtersContent, filtersContentItems } = this.$ui
    const { expanded } = this.dynamicClasses

    filters.classList.toggle(expanded)

    if (window.innerWidth >= 1024) {
      filtersContent.style.height = filters.classList.contains(expanded)
        ? filtersContent.dataset.height
        : 0
    } else {
      if (!filters.classList.contains(expanded)) {
        setTimeout(() => {
          filtersContentItems.forEach((column) => {
            column.parentElement.classList.remove(expanded)
            column.style.height = 0
          })
        }, 500)
      }
    }
  }

  handleScroll(position) {
    const { controls, filters } = this.$ui
    const { allowSticky, sticky, stickyExt, border, expanded } =
      this.dynamicClasses

    if (!controls.classList.contains(allowSticky)) {
      return
    }

    const stickyBreakpoint = 50
    const stickyExtBreakpoint = stickyBreakpoint + 7
    const borderBreakpoint = stickyBreakpoint + 80
    const filtersAppliedBreakpoint = stickyBreakpoint + 20
    const isSticky = position >= stickyBreakpoint
    const isStickyExt = position >= stickyExtBreakpoint
    const hasBorder = position >= borderBreakpoint
    const filtersAppliedOffset = Math.max(
      Math.min(filtersAppliedBreakpoint - position, 0),
      -49
    )

    if (isSticky && !controls.classList.contains(sticky)) {
      controls.classList.add(sticky)
    } else if (!isSticky && controls.classList.contains(sticky)) {
      controls.classList.remove(sticky)
    }

    if (isStickyExt && !controls.classList.contains(stickyExt)) {
      controls.classList.add(stickyExt)
    } else if (!isStickyExt && controls.classList.contains(stickyExt)) {
      controls.classList.remove(stickyExt)
    }

    if (hasBorder && !controls.classList.contains(border)) {
      controls.classList.add(border)
    } else if (!hasBorder && controls.classList.contains(border)) {
      controls.classList.remove(border)
    }

    controls.style.setProperty(
      "--filters-applied-offset",
      `${filtersAppliedOffset}px`
    )
  }

  handleSubmit(event) {
    const { controls } = this.$ui
    const formData = new FormData(controls)
    event.preventDefault()
    const searchParams = new URLSearchParams(formData).toString()
    this.renderPage(searchParams, event)
  }

  checkIfInsideCategory() {
    const isInsidecategory = !!document.querySelector(
      ".collection-filters-content-items[data-inside-category]"
    )
    return isInsidecategory
  }

  renderPage(searchParams, event, updateURLHash = true) {
    const { productGridContainer } = this.$ui
    const { loading } = this.dynamicClasses
    const isInsideCategory = this.checkIfInsideCategory()
    let params = new URLSearchParams(searchParams)

    const filteredParams = new URLSearchParams()

    for (const validParam of VALID_PARAMS) {
      const values = params.getAll(validParam)
      if (values.length > 0) {
        for (const value of values) {
          filteredParams.append(validParam, value)
        }
      }
    }

    params = filteredParams
    searchParams = params.toString()

    let pathname = window.location.pathname
    const loadCategory =
      isInsideCategory &&
      params.get("category") !== this.$el.dataset.collectionHandle
    const productGrid = productGridContainer.querySelector(".product-grid")

    if (isInsideCategory) {
      const category = params.get("category") || "all-products"
      pathname = `${Shopify.routes.root}collections/${category}`
      params.delete("category")
      searchParams = params.toString()
      this.$el.dataset.collectionHandle = category
    } else {
      if (params.get("category") === "all-products") {
        params.delete("category")
        searchParams = params.toString()
      }
    }

    if (params.get("sort_by") === "manual") {
      params.delete("sort_by")
      searchParams = params.toString()
    }

    this.searchParamsPrev = searchParams

    if (loadCategory) {
      const id = productGrid.dataset.id
      // const url = `${pathname}/?section_id=${id}&${searchParams}`
      const url = `${pathname}/?section_id=${id}`
      productGridContainer.classList.add(loading)
      this.renderSectionFromFetch(url, searchParams, event)
    } else {
      this.renderProductGrid(searchParams)
    }

    if (updateURLHash) {
      this.updateURLHash(searchParams, pathname)
    }

    this.renderAppliedFilters()
  }

  renderSectionFromFetch(url, searchParams, event) {
    const { productGridContainer } = this.$ui
    const { loading } = this.dynamicClasses

    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText
        // this.renderFilters(html, event)
        this.renderProductGridContainer(html, searchParams)
        productGridContainer.classList.remove(loading)
        this.initLazyLoading()
      })
  }

  renderFilters(searchParams) {
    const { filtersContentItems, sortLabel, sortOptions } = this.$ui
    const { active } = this.dynamicClasses
    const params = new URLSearchParams(searchParams)
    const sortBy = params.get("sort_by") || "manual"

    iterable(filtersContentItems).forEach((filter) => {
      const type = filter.dataset.filter
      const inputs = filter.querySelectorAll("input")
      iterable(inputs).forEach((input) => {
        input.checked = params.getAll(type).includes(input.value)
      })

      if (type === "category" && !params.get("category")) {
        const inputAll = filter.querySelector(`input[value="all-products"]`)
        inputAll.checked = true
      }
    })

    iterable(sortOptions).forEach((option) => {
      const input = option.querySelector("input")
      option.classList.toggle(active, input.value === sortBy)
      if (input.value === sortBy) {
        input.checked = true
        sortLabel.innerHTML = input.dataset.label
      }
    })
  }

  updateFiltersAvailability(searchParams) {
    const { filtersContentItems } = this.$ui
    const { disabled } = this.dynamicClasses
    const params = new URLSearchParams(searchParams)
    const categoryParam = params.getAll("category")
    const materialParam = params.getAll("material")
    const stoneParam = params.getAll("stone")

    iterable(filtersContentItems).forEach((filter) => {
      const type = filter.dataset.filter
      if (!this.checkIfInsideCategory() || type !== "category") {
        const inputs = filter.querySelectorAll("input")
        iterable(inputs).forEach((input) => {
          let isAvailable
          if (
            (type === "material" &&
              categoryParam.length > 0 &&
              categoryParam[0] !== "all-products") ||
            (type === "stone" &&
              categoryParam.length > 0 &&
              categoryParam[0] !== "all-products")
          ) {
            isAvailable = this.getAvailability(
              type,
              categoryParam,
              "category",
              input
            )
          } else if (
            (type === "category" && materialParam.length > 0) ||
            (type === "stone" && materialParam.length > 0)
          ) {
            isAvailable = this.getAvailability(
              type,
              materialParam,
              "material",
              input
            )
          } else if (
            (type === "category" && stoneParam.length > 0) ||
            (type === "material" && stoneParam.length > 0)
          ) {
            isAvailable = this.getAvailability(type, stoneParam, "stone", input)
          } else {
            isAvailable =
              input.value === "all-products" ||
              this.productsArr.some((item) => item[type].includes(input.value))
          }

          input.parentElement.classList.toggle(disabled, !isAvailable)
        })
      }
    })
  }

  getAvailability(type, param, paramName, input) {
    return (
      input.checked ||
      input.value === "all-products" ||
      this.productsArr.some(
        (item) =>
          param.some((i) => item[paramName].includes(i)) &&
          item[type].includes(input.value)
      )
    )
  }

  renderAppliedFilters() {
    const {
      controls,
      filtersContentItems,
      filtersApplied,
      filtersAppliedItems,
    } = this.$ui
    const { empty, filtersAppliedEmpty } = this.dynamicClasses
    const isInsideCategory = this.checkIfInsideCategory()
    let tagCount = 0

    const elements = document.createDocumentFragment()
    iterable(filtersContentItems).forEach((filter) => {
      if (!(isInsideCategory && filter.dataset.filter === "category")) {
        const activeFilters = filter.querySelectorAll("input:checked")
        iterable(activeFilters).forEach((input) => {
          if (input.value !== "all-products") {
            this.addTag(input.name, input.dataset.fullName, elements)
            tagCount++
          }
        })
      }
    })

    filtersApplied.classList.toggle(empty, tagCount === 0)
    controls.classList.toggle(filtersAppliedEmpty, tagCount === 0)
    filtersAppliedItems.innerHTML = null
    filtersAppliedItems.appendChild(elements)
    this.checkFiltersAppliedMultiRows()
  }

  addTag(type, name, parent) {
    const tag = document.createElement("div")
    tag.innerHTML = `${name} <button class="tag-delete" type="button" aria-label="Delete"><svg class="icon icon-x"><use xlink:href="#x" href="#x"></use></svg></button>`
    tag.classList.add("tag")
    tag.dataset.type = type
    tag.dataset.name = name
    parent.appendChild(tag)
  }

  renderProductGrid(searchParams) {
    const { productGridContainer } = this.$ui
    const { hidden, customBlocksHidden } = this.dynamicClasses
    const params = new URLSearchParams(searchParams)
    const sortBy = params.get("sort_by")
    const categoryParam = params.getAll("category")
    const materialParam = params.getAll("material")
    const stoneParam = params.getAll("stone")
    const areCustomBlocksHidden =
      (sortBy && sortBy !== "manual") ||
      (categoryParam.length > 0 && categoryParam[0] !== "all-products") ||
      materialParam.length > 0 ||
      stoneParam.length > 0
    let productsToRender
    const productGrid = productGridContainer.querySelector(".product-grid")

    if (sortBy === "created-descending") {
      productsToRender = this.productsArr.sort((a, b) => {
        return b.created - a.created
      })
    } else if (sortBy === "price-ascending") {
      productsToRender = this.productsArr.sort((a, b) => {
        return a.price - b.price
      })
    } else if (sortBy === "price-descending") {
      productsToRender = this.productsArr.sort((a, b) => {
        return b.price - a.price
      })
    } else {
      productsToRender = this.productsArr.sort((a, b) => {
        return a.manualOrder - b.manualOrder
      })
    }

    const elements = document.createDocumentFragment()
    productsToRender.forEach((item) => {
      let isHidden = false
      const node = document.getElementById(`product-${item.id}`)
      if (
        (categoryParam.length > 0 &&
          categoryParam[0] !== "all-products" &&
          !item.category.some((i) => categoryParam.includes(i))) ||
        (materialParam.length > 0 &&
          !item.material.some((i) => materialParam.includes(i))) ||
        (stoneParam.length > 0 &&
          !item.stone.some((i) => stoneParam.includes(i)))
      ) {
        isHidden = true
      }
      item.hidden = isHidden
      node.classList.toggle(hidden, isHidden)
      elements.appendChild(node)
    })
    productGrid.appendChild(elements)
    productGrid.classList.toggle(customBlocksHidden, areCustomBlocksHidden)
    const productsCount = productsToRender.filter((item) => !item.hidden).length
    productGrid.dataset.count = productsCount
    this.updateFiltersAvailability(searchParams)
  }

  getProductsArr() {
    const { productGridContainer } = this.$ui
    const items = productGridContainer.querySelectorAll(
      ".product-grid-item[id]"
    )
    const arr = []
    iterable(items).forEach((item) => {
      const { id, manualOrder, created, price, category, material, stone } =
        item.dataset
      arr.push({
        id,
        manualOrder,
        created,
        price,
        category: category ? category.split(", ") : [],
        material: material ? material.split(", ") : [],
        stone: stone ? stone.split(", ") : [],
        hidden: false,
      })
    })
    this.productsArr = arr
    return arr
  }

  renderProductGridContainer(html, searchParams) {
    const { productGridContainer } = this.$ui
    const parsed = new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(".product-grid-container")
    if (parsed) {
      this.removeNodes(parsed, ".product-grid-custom-block")
      productGridContainer.innerHTML = parsed.innerHTML
      this.getProductsArr()
      this.renderProductGrid(searchParams)
    }
  }

  removeNodes(fragment, selector) {
    const nodes = fragment.querySelectorAll(selector)
    iterable(nodes).forEach((node) => {
      node.remove()
    })
  }

  updateURLHash(searchParams, pathname) {
    history.pushState(
      { searchParams },
      "",
      `${pathname}${searchParams && "?".concat(searchParams)}`
    )
  }

  onActiveFilterClick(event) {
    const { filtersContent } = this.$ui
    const tag = event.target.closest(".tag")
    const { type, name } = tag.dataset
    const input = filtersContent.querySelector(
      `input[name="${type}"][data-full-name="${name}"]`
    )

    input.checked = false
    if (input.type === "radio") {
      const inputAll = filtersContent.querySelector(
        `input[name="${type}"][value="all-products"]`
      )
      inputAll.checked = true
    }
    this.handleSubmit(event)
  }

  onHistoryChange(event) {
    let searchParams =
      event && event.state ? event.state.searchParams : this.searchParamsInitial

    if (searchParams) {
      const params = new URLSearchParams(searchParams)
      const filteredParams = new URLSearchParams()

      for (const validParam of VALID_PARAMS) {
        const values = params.getAll(validParam)
        if (values.length > 0) {
          for (const value of values) {
            filteredParams.append(validParam, value)
          }
        }
      }

      searchParams = filteredParams.toString()
    }

    if (
      window.location.pathname.includes("/collections") &&
      this.checkIfInsideCategory()
    ) {
      const category = window.location.pathname.split("/")[2]
      if (category) {
        searchParams =
          (searchParams ? searchParams + "&" : "") + `category=${category}`
      }
    }
    this.renderPage(searchParams, null, false)
    this.renderFilters(searchParams)
    this.renderAppliedFilters(searchParams)
  }

  checkFiltersAppliedMultiRows() {
    const { filtersApplied, filtersAppliedItems } = this.$ui
    const { multiRows } = this.dynamicClasses
    const hasMultiRows = filtersAppliedItems.offsetHeight > 45

    filtersApplied.classList.toggle(multiRows, hasMultiRows)
  }

  attachEvents() {
    const {
      controls,
      filters,
      filtersToggle,
      filtersColumnTitle,
      filtersContentColumnTitles,
      filtersContentItems,
      filtersContentControlsButtons,
      filtersAppliedToggle,
      sortLabel,
      sortOptions,
      sortInputs,
      productGridContainer,
    } = this.$ui
    const { expanded, active, open } = this.dynamicClasses

    filtersToggle.addEventListener("click", () => {
      this.toggleFilters()
    })

    controls.addEventListener("submit", (e) => {
      this.handleSubmit(e)
    })

    controls.addEventListener("input", (e) => {
      this.handleSubmit(e)
    })

    controls.addEventListener("click", (event) => {
      if (event.target.classList.contains("tag-delete")) {
        this.onActiveFilterClick(event)
      }
    })

    window.addEventListener("popstate", (event) => {
      this.onHistoryChange(event)
    })

    iterable(sortInputs).forEach((input, index) => {
      input.addEventListener("change", () => {
        sortLabel.innerHTML = input.dataset.label
        iterable(sortOptions).forEach((option, optionIndex) => {
          option.classList.toggle(active, index == optionIndex)
        })
      })
    })

    if (window.innerWidth >= 1024) {
      filtersToggle.addEventListener("click", () => {
        window.scrollTo(0, 0)
      })

      filtersAppliedToggle.addEventListener("click", () => {
        filtersAppliedToggle.parentElement.classList.toggle(expanded)
      })

      this.checkFiltersAppliedMultiRows()

      window.addEventListener(
        "resize",
        debounce((e) => {
          this.checkFiltersAppliedMultiRows()
        })
      )

      window.addEventListener("wheel", (e) => {
        if (e.deltaY > 1 && filters.classList.contains(expanded)) {
          this.toggleFilters()
        }
      })

      productGridContainer.addEventListener(
        "mouseenter",
        (e) => {
          if (
            e.target.tagName.toLowerCase() === "video" &&
            !e.target.closest(".-not-hover-played")
          ) {
            if (e.target.paused) {
              e.target.play()
            }
          }
        },
        true
      )

      productGridContainer.addEventListener(
        "mouseleave",
        (e) => {
          if (
            e.target.tagName.toLowerCase() === "video" &&
            !e.target.closest(".-not-hover-played")
          ) {
            e.target.pause()
          }
        },
        true
      )
    } else {
      filtersColumnTitle.addEventListener("click", () => {
        this.toggleFilters()
      })

      iterable(filtersContentColumnTitles).forEach((title, index) => {
        title.addEventListener("click", () => {
          const items = filtersContentItems[index]
          title.parentElement.classList.toggle(expanded)
          items.style.height = title.parentElement.classList.contains(expanded)
            ? items.dataset.height
            : 0
        })
      })

      iterable(filtersContentControlsButtons).forEach((button) => {
        button.addEventListener("click", () => {
          filters.classList.remove(expanded)
        })
      })

      document.body.addEventListener(
        "touchmove",
        (e) => {
          if (
            filters.classList.contains(expanded) &&
            !e.target.closest(".collection-filters-content-items")
          ) {
            e.preventDefault()
          }
        },
        {
          passive: false,
        }
      )
    }
  }

  initLazyLoading() {
    const { productGridContainer } = this.$ui
    const { initObserved, notObserved } = this.dynamicClasses
    const items = productGridContainer.querySelectorAll(".product-grid-item")
    const lazyLoadObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add(initObserved)
            entry.target.classList.remove(notObserved)
            iterable(entry.target.querySelectorAll("img[data-srcset]")).forEach(
              (img) => {
                img.setAttribute("srcset", img.dataset.srcset)
              }
            )
          }
        })
      },
      {
        rootMargin: "1000px",
      }
    )

    iterable(items).forEach((item, index) => {
      if (!item.classList.contains(initObserved)) {
        setTimeout(
          () => {
            lazyLoadObserver.observe(item)
          },
          index < 12 ? 0 : 1000
        )
      }
    })
  }

  created() {
    this.searchParamsInitial = window.location.search.slice(1)

    if (this.searchParamsInitial) {
      const params = new URLSearchParams(this.searchParamsInitial)
      const filteredParams = new URLSearchParams()

      for (const validParam of VALID_PARAMS) {
        const values = params.getAll(validParam)
        if (values.length > 0) {
          for (const value of values) {
            filteredParams.append(validParam, value)
          }
        }
      }

      this.searchParamsInitial = filteredParams.toString()
    }

    this.searchParamsPrev = this.searchParamsInitial

    this.getProductsArr()
    this.updateFiltersAvailability()

    if (this.searchParamsInitial) {
      this.onHistoryChange()
    }

    this.setHeights()
    this.attachEvents()
    this.initLazyLoading()

    if (window.innerWidth >= 1024) {
      scrollLoop(() => {
        this.handleScroll(window.pageYOffset)
      })
    }
  }
}
